import * as React from 'react'
import Footer from '../../sections/footer'
import WaveContainer from '../../components/wave-container'

import Hero from './components/hero'
import Intro from './components/intro'
import Images from './components/images'
import Contact from './components/contact'
import Social from './components/social'
import Mission from './components/mission'
import Media from '../../sections/media'
import Seo from '../../components/seo'

const Career = () => {
  return (
    <>
      <Seo
        description="Här hittar du material att använda för pressinlägg, nyheter och artiklar. "
        image="https://www.dooer.com/images/og/og_index.jpg"
        title="Press & Material | Dooer"
        url="https://www.dooer.com/press"
      />

      <Hero />
      <WaveContainer>
        <Intro />
      </WaveContainer>
      <Images />
      <Social />
      <Mission />
      <Contact />
      <Media />
      <Footer />
    </>
  )
}

export default Career
